import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import { colors } from "../setupUtils";
import { Divider } from "@mui/material";
import AutoComplete from "./AutoComplete";
import EditIndividualCustomerDate from "./EditIndividualCustomerDate";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1300,
  height: 540,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

export default function BasicModal() {
   const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        startIcon={<EditCalendarIcon />}
        disabled={!isRestrictedAccess}
        sx={{
          bgcolor: "blue.main",
          color: "white.main",
          textTransform: "none",
          ml: "auto",
          mt: 3,
          mb: 3,
          // float: "right",
          "&:hover": {
            bgcolor: colors.lightBlue,
          },
          marginLeft: "calc(100% - 165px)",
        }}
        onClick={handleOpen}
      >
        Update Dates
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography sx={{ ml: 1, fontWeight: "bold", color: "blue.main" }}>
            Edit Customer Start Date / End Date
          </Typography>
          <Divider sx={{ mb: 3 }} />
          {/* <AutoComplete /> */}
          <EditIndividualCustomerDate />
          <Box>
            <Button
              sx={{
                bgcolor: "blue.main",
                color: "white.main",
                textTransform: "none",
                fontWeight: "bold",
                position: "fixed",
                bottom: 10,
                right: 20,
                zIndex: 1,
                "&:hover": {
                  bgcolor: "skyBlue.main",
                  color: "black.main",
                },
              }}
              onClick={handleClose}
            >
              Save Dates
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
